import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/20/solid';

export default function PrivacyPolicy() {
  return (
    <div className="bg-white px-6 py-32 lg:px-8">
      <div className="mx-auto max-w-3xl text-base/7 text-gray-700">
        <p className="text-base/7 font-semibold text-primary">NCC BRO DRIVER DI BRODETCHI ANDREI</p>
        <h1 className="mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
          Informativa sulla Privacy
        </h1>
        <p className="mt-6 text-xl/8">
          Questa informativa descrive le modalità di raccolta e trattamento dei dati personali degli
          utenti che navigano il sito web di NCC BRO DRIVER DI BRODETCHI ANDREI (“Società”), incluso
          l’utilizzo del modulo di contatto. La presente policy è redatta in conformità al
          Regolamento UE 2016/679 (GDPR) e alla normativa nazionale applicabile.
        </p>
        <div className="mt-10 max-w-2xl text-gray-600">
          <h2 className="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">
            1. Titolare del trattamento
          </h2>
          <p className="mt-6">NCC BRO DRIVER DI BRODETCHI ANDREI P.Iva & C.F n. 04634240982</p>
          <h2 className="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">
            2. Dati raccolti
          </h2>
          <p className="mt-6">
            Possono essere raccolti i seguenti dati personali tramite il sito e il modulo di
            contatto:
          </p>
          <ul className="mt-8 max-w-xl space-y-8 text-gray-600">
            <li className="flex gap-x-3">
              <CheckCircleIcon
                aria-hidden="true"
                className="mt-1 size-5 flex-none text-indigo-600"
              />
              <span>
                <strong className="font-semibold text-gray-900">Nome e cognome</strong>
              </span>
            </li>
            <li className="flex gap-x-3">
              <CheckCircleIcon
                aria-hidden="true"
                className="mt-1 size-5 flex-none text-indigo-600"
              />
              <span>
                <strong className="font-semibold text-gray-900">Indirizzo email</strong>
              </span>
            </li>
            <li className="flex gap-x-3">
              <CheckCircleIcon
                aria-hidden="true"
                className="mt-1 size-5 flex-none text-indigo-600"
              />
              <span>
                <strong className="font-semibold text-gray-900">
                  Numero di telefono (se inserito)
                </strong>
              </span>
            </li>
            <li className="flex gap-x-3">
              <CheckCircleIcon
                aria-hidden="true"
                className="mt-1 size-5 flex-none text-indigo-600"
              />
              <span>
                <strong className="font-semibold text-gray-900">
                  Qualsiasi altro dato fornito volontariamente dall’utente nel messaggio
                </strong>
              </span>
            </li>
            <li className="flex gap-x-3">
              <CheckCircleIcon
                aria-hidden="true"
                className="mt-1 size-5 flex-none text-indigo-600"
              />
              <span>
                <strong className="font-semibold text-gray-900">
                  Dati di navigazione (es. indirizzo IP, browser, dispositivo, cookie, data e ora)
                </strong>
              </span>
            </li>
          </ul>
          <h2 className="mt-16 text-pretty text-3xl font-semibold tracking-tight text-gray-900">
            3. Finalità e Base Giuridica del Trattamento
          </h2>
          <p className="mt-6">I dati sono trattati per le seguenti finalità:</p>
          <ul className="mt-8 max-w-xl space-y-8 text-gray-600">
            <li className="flex gap-x-3">
              <CheckCircleIcon
                aria-hidden="true"
                className="mt-1 size-5 flex-none text-indigo-600"
              />
              <span>
                <strong className="font-semibold text-gray-900">
                  Rispondere a richieste di informazioni inviate tramite il modulo di contatto
                  (consenso dell’interessato)
                </strong>
              </span>
            </li>
            <li className="flex gap-x-3">
              <CheckCircleIcon
                aria-hidden="true"
                className="mt-1 size-5 flex-none text-indigo-600"
              />
              <span>
                <strong className="font-semibold text-gray-900">
                  Gestione tecnica e sicurezza del sito web (interesse legittimo del titolare)
                </strong>
              </span>
            </li>
            <li className="flex gap-x-3">
              <CheckCircleIcon
                aria-hidden="true"
                className="mt-1 size-5 flex-none text-indigo-600"
              />
              <span>
                <strong className="font-semibold text-gray-900">
                  Adempimenti previsti da normative vigenti o da ordini dell’Autorità (obbligo
                  legale)
                </strong>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
